import EventTimeline from './EventTimeline';

export default EventTimeline;

export type {
  EventTimelineField,
  EventTimelineStatusVariant,
  EventTimelineTone,
  IEventTimelineColumn,
  IEventTimelineEvent,
  IEventTimelineProps
} from './EventTimeline';
